import React, { useState } from 'react';
import styled from 'styled-components';
import { Intro } from './../Calculators/Intro';
import { ButtonPanel } from './../Calculators/ButtonPanel';
import { OneColumnLayout } from './../Calculators/Sections';
import { ChartSeries } from './ChartSeries';
import { TableSeries } from './TableSeries';
import {Button, ButtonLink, RangerInput, TextInput} from './../Form/index';
import { HousePrice, RepaymentOptions } from './LeftPanel';
import { ClientLoan } from './ClientLoan';
import {ErrorBox} from "./Sidebar";
import html2canvas from 'html2canvas';

const titleRepayment = [
  `Enter some details about your client\'s property and the repayments they might look
  to make to see the effect it could have on their loan and the equity in their home.`
];

const PartialRepayment = styled.div`
  h1 { text-align: center; color: #0a2f70; }
`;

function toDataURL(url, callback)
{
  let xhr = new XMLHttpRequest();

  xhr.onload = function()
  {
    let reader = new FileReader();

    reader.onloadend = function()
    {
      callback(reader.result);
    }

    reader.readAsDataURL(xhr.response);
  };

  xhr.open('GET', url);
  xhr.responseType = 'blob';
  xhr.send();
}

function changeStage(currentStage, desiredStage, onChangeInput)
{
  if(desiredStage > currentStage)
  {
    return false;
  }

  onChangeInput('stage', desiredStage);
}

function menuBar(stage, onChangeInput)
{
  return (
    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '50px', marginBottom: '50px'}}>
      <div onClick={() => changeStage(stage, 1, onChangeInput)} style={{cursor: 'pointer', background: (stage === 1) ? '#86B42D' : 'rgba(32,149,70,0.4)', width: 167, height: 75, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <img style={{width: '20px', height: '24px', paddingLeft: '12px', paddingRight: '12px'}} src={'/images/tab_client.png'}/>
        <h1 style={{color: 'white', fontSize: '16px', fontWeight: '700', margin: 0, fontFamily: 'Nunito Sans'}}>Client details</h1>
      </div>
      <div onClick={() => changeStage(stage, 2, onChangeInput)} style={{cursor: 'pointer', background: (stage === 2) ? '#86B42D' : 'rgba(32,149,70,0.4)', width: 167, height: 75, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <img style={{width: '20px', height: '24px', paddingLeft: '12px', paddingRight: '12px'}} src={'/images/tab_loan.png'}/>
        <h1 style={{color: 'white', fontSize: '16px', fontWeight: '700', margin: 0, fontFamily: 'Nunito Sans'}}>Loan details</h1>
      </div>
      <div onClick={() => changeStage(stage, 3, onChangeInput)} style={{cursor: 'pointer', background: (stage === 3) ? '#86B42D' : 'rgba(32,149,70,0.4)', width: 167, height: 75, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <img style={{width: '20px', height: '24px', paddingLeft: '12px', paddingRight: '12px'}} src={'/images/tab_repayments.png'}/>
        <h1 style={{color: 'white', fontSize: '16px', fontWeight: '700', margin: 0, fontFamily: 'Nunito Sans'}}>Repayments</h1>
      </div>
      <div onClick={() => changeStage(stage, 4, onChangeInput)} style={{cursor: 'pointer', background: (stage === 4) ? '#86B42D' : 'rgba(32,149,70,0.4)', width: 167, height: 75, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <img style={{width: '20px', height: '24px', paddingLeft: '12px', paddingRight: '12px'}} src={'/images/tab_drawdown.png'}/>
        <h1 style={{color: 'white', fontSize: '16px', fontWeight: '700', margin: 0, fontFamily: 'Nunito Sans'}}>Drawdown & Further Borrowing</h1>
      </div>
      <div onClick={() => changeStage(stage, 5, onChangeInput)} style={{cursor: 'pointer', background: (stage === 5) ? '#86B42D' : 'rgba(32,149,70,0.4)', width: 167, height: 75, display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
        <img style={{width: '20px', height: '24px', paddingLeft: '12px', paddingRight: '12px'}} src={'/images/tab_results.png'}/>
        <h1 style={{color: 'white', fontSize: '16px', fontWeight: '700', margin: 0, fontFamily: 'Nunito Sans'}}>Results</h1>
      </div>
    </div>
  )
}

function handleEmailSend(partialRepayment, onChangeInput)
{
  onChangeInput('privacyError', false);

  if(!partialRepayment.input.formPrivacyAgree)
  {
    onChangeInput('privacyError', true);

    return;
  }

  fetch('https://rer-api-dev.moreish.host/process_email.php', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      formName: partialRepayment.input.formName,
      formEmail: partialRepayment.input.formEmail,
      formCompany: partialRepayment.input.formCompany,
      formCaseNumber: partialRepayment.input.formCaseNumber,
      formMessage: partialRepayment.input.formMessage,
      formPrivacyAgree: "YES"
    })
  })

  onChangeInput('displayForm', false);
  onChangeInput('displayFormComplete', true);
}

function handleAdhocChange(type, year, onChangeInput, currentData, newValue)
{
  currentData[year] = newValue;

  onChangeInput(type, currentData);
}

export const PartialRepaymentComponent = ({ screen, partialRepayment, onChangeInput }) => {
  let repaymentLevels = 1;

  let tableGraph = "";

  let drawdownSum = Object.values(partialRepayment.input.adHocDrawdown).reduce((partialSum, a) => parseInt(partialSum) + parseInt(a), 0);

  let adhocPaymentValues = Object.values(partialRepayment.input.adHocPayments);

  if(partialRepayment.input.stage === 0)
  {
    return (
      <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments calculator</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in their home</h1>
        {menuBar(1, onChangeInput)}
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', marginBottom: '50px'}}>
          Would you like a personalised or quick search?
        </h1>
        <div style={{width: '166px', margin: '67px auto'}}>
          <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 1)}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', background: '#209546', padding: '16px', width: '166px', color: 'white', textAlign: 'left'}}>
              Quick Search
              <img style={{width: '10px', height: '16px'}} src={'/images/icon_next.png'}/>
            </div>
          </a>
        </div>
        <div style={{width: '166px', margin: '32px auto'}}>
          <a href="#" style={{textDecoration: 'none', width: '166px', margin: '32px auto'}} onClick={() => onChangeInput('stage', 0.5)}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', background: '#86B42D', padding: '16px', width: '166px', color: 'white', textAlign: 'left'}}>
              Personalised Search
              <img style={{width: '10px', height: '16px'}} src={'/images/icon_next.png'}/>
            </div>
          </a>
        </div>
      </div>
    );
  }

  if(partialRepayment.input.stage === 0.5) {
    return (
      <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments
          calculator</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple
          steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in
          their home</h1>
        {menuBar(1, onChangeInput)}
        <h1 style={{
          color: '#0D2926',
          fontFamily: 'Nunito Sans',
          fontWeight: 400,
          fontSize: '16px',
          marginBottom: '50px'
        }}>
          Enter your adviser details
        </h1>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '30px'}}>
          <div style={{marginRight: '30px'}}>
            <h1 style={{textAlign: 'left', fontSize: '16px', fontWeight: '400', fontFamily: 'Nunito Sans'}}>Adviser Name</h1>
          </div>
          <TextInput
            width={300} style={{ textAlign: 'left' }}
            type="text" value={partialRepayment.input.advisorName}
            onChange={val => { onChangeInput('advisorName', val); }}
          />
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '30px'}}>
          <div style={{marginRight: '30px'}}>
            <h1 style={{textAlign: 'left', fontSize: '16px', fontWeight: '400', fontFamily: 'Nunito Sans'}}>Adviser Logo</h1>
          </div>
          <input
            type="file"
            name="fileUpload"
            onChange={(event) => {
              let img = event.target.files[0];

              toDataURL(URL.createObjectURL(img), function(dataUrl) {
                onChangeInput('logo', dataUrl);
              })
            }}
          />
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '48px', paddingRight: '32px'}}>
          <div style={{width: '166px'}}>
            <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 1)}>
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', background: '#209546', padding: '16px', width: '166px', color: 'white', textAlign: 'left'}}>
                Next
                <img style={{width: '10px', height: '16px'}} src={'/images/icon_next.png'}/>
              </div>
            </a>
          </div>
        </div>
      </div>
    );
  }

  if(partialRepayment.input.stage === 1)
  {
    return (
      <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments calculator</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in their home</h1>
        {menuBar(1, onChangeInput)}
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', marginBottom: '50px'}}>
          Start by entering a few simple client details to find out
          <br/>
          <span style={{ color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>how much your client could borrow</span>
        </h1>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
          <img style={{width: '40px', height: '36px', marginRight: '20px'}} src={'/images/icon_date.png'}/>
          <div style={{marginRight: '30px'}}>
            <h1 style={{textAlign: 'left', fontSize: '16px', fontWeight: '400', margin: '0 0 10px 0', fontFamily: 'Nunito Sans'}}>Client age</h1>
            <h1 style={{textAlign: 'left', fontSize: '12px', fontWeight: '400', margin: 0, fontFamily: 'Nunito Sans'}}>Need to be 55 or older to<br/>qualify for equity release<br/>(If joint life, enter youngest age)</h1>
          </div>
          <RangerInput
            className="hl"
            value={partialRepayment.input.clientAge} min={55} max={90}
            color='#0a2f70' inactiveColor='#f1f9ff' withLabel={true} suffix={''}
            onChange={val => { onChangeInput('clientAge', val); }}
          />
        </div>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '30px'}}>
          <img style={{width: '40px', height: '36px', marginRight: '20px'}} src={'/images/icon_home.png'}/>
          <div style={{marginRight: '30px'}}>
            <h1 style={{textAlign: 'left', fontSize: '16px', fontWeight: '400', fontFamily: 'Nunito Sans'}}>Current property value</h1>
          </div>
          <TextInput
            width={150} style={{ textAlign: 'right' }}
            type="currency" prefixes="&pound;" value={partialRepayment.input.housePrice}
            onChange={val => { onChangeInput('housePrice', val);  onChangeInput('capitalValue1', Math.round(parseInt(partialRepayment.output.maxYearlyLoan, 10))) }}
          />
        </div>
        <div style={{marginBottom: '16px', marginTop: '24px', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
          <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
            <div onClick={() => { onChangeInput('isJoint', false); }} style={{position: 'relative'}}>
              <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
              {(partialRepayment.input.isJoint == false) ? (
                <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
              ): false}
            </div>
            <div style={{marginLeft: '32px', marginTop: '-10px'}}>
              <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Single Life</h1>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px', marginLeft: '24px'}}>
            <div onClick={() => { onChangeInput('isJoint', true); }} style={{position: 'relative'}}>
              <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
              {(partialRepayment.input.isJoint == true) ? (
                <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
              ): false}
            </div>
            <div style={{marginLeft: '32px', marginTop: '-10px'}}>
              <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Joint Life</h1>
            </div>
          </div>
        </div>
        {(70000 > partialRepayment.input.housePrice) ? (
          <div style={{ marginTop: 20, color: 'red', fontSize: '12px' }}>
            The minimum property value is £70,000
          </div>
        ):
          <div style={{width: '166px', margin: '67px auto'}}>
            <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 2)}>
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', background: '#209546', padding: '16px', width: '166px', color: 'white', textAlign: 'left'}}>
                Start
                <img style={{width: '10px', height: '16px'}} src={'/images/icon_next.png'}/>
              </div>
            </a>
          </div>
        }
      </div>
    );

  }

  if(partialRepayment.input.stage === 2)
  {
    return (
      <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments calculator</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in their home</h1>
        {menuBar(2, onChangeInput)}
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '0 100px'}}>
          <div style={{width: '100px', textAlign: 'center'}}>
            <img style={{width: '53px', height: '60px'}} src={'/images/icon_coin_small.png'}/>
            <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>£10,000<br/>Minimum</h1>
          </div>
          <div style={{flexGrow: true, width: '100%', flexDirection: 'column'}}>
            <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>Here’s how much your client could release from their home</h1>
            <div style={{width: '90%', height: '1px', borderTop: '1px dashed #0D2926', margin: '0 auto'}}></div>
            <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>to</h1>
          </div>
          <div style={{width: '109px'}}>
            <img style={{width: '109px', height: '80px'}} src={'/images/icon_coin_large.png'}/>
            <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>£{partialRepayment.output.ltv.max.toLocaleString()}<br/>Maximum</h1>
          </div>
        </div>
        <div style={{background: '#F2F2F2', padding: '48px', marginTop: '40px', textAlign: 'left'}}>
          <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>Tell us how much your client would like to borrow:</h1>
          <div style={{width: '100%', height: '1px', borderTop: '1px solid #0D2926', margin: '20px auto'}}></div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <div style={{width: '40px'}}>
                <img style={{width: '32px', height: '24px'}} src={'/images/icon_money.png'}/>
              </div>
              <div style={{width: '300px', marginLeft: '10px'}}>
                <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Desired initial loan amount</h1>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <TextInput
                  width={150} style={{ textAlign: 'right' }}
                  type="currency" prefixes="&pound;" value={partialRepayment.input.loanTaken}
                  onChange={val => { onChangeInput('loanTaken', val) }}
                />
                {(partialRepayment.input.loanTaken > partialRepayment.output.ltv.max) ? (
                    <div style={{ marginLeft: 20, marginRight: 20, color: 'red', fontSize: '12px' }}>
                      The loan amount exceed the maximum available
                    </div>
                ): false}
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '45px'}}>
              <div style={{width: '40px'}}>
                <img style={{width: '23px', height: '30px'}} src={'/images/icon_bag.png'}/>
              </div>
              <div style={{width: '300px', marginLeft: '10px'}}>
                <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Loan MER (%)</h1>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                  <TextInput
                    id={'interestTaken'}
                    width={150}
                    style={{ textAlign: 'right', width: 120 }}
                    type="decimal"
                    prefixes="%"
                    value={partialRepayment.input.interestTaken}
                    min={2.25}
                    max={9.99}
                    step={0.01}
                    onChange={val => { onChangeInput('interestTaken', val) }}
                  />
              </div>
            </div>
            <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '45px'}}>
              <div style={{width: '40px'}}>
                <img style={{width: '32px', height: '24px'}} src={'/images/icon_graph.png'}/>
              </div>
              <div style={{width: '300px', marginLeft: '10px'}}>
                <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Future house value</h1>
                <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px'}}>See a projection of the future value<br/>of your client’s home with an annual<br/>average increase or decrease of -5 to 5%</h1>
              </div>
              <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                <RangerInput
                  className="ranger"
                  value={partialRepayment.input.futureHousePricePct} min={-5} max={5} div={4} type='float'
                  inactiveColor='#bbbbbb' withLabel={true}
                  onChange={val => { onChangeInput('futureHousePricePct', val) }}
                />
              </div>
            </div>
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '48px', paddingRight: '32px'}}>
            <div style={{width: '166px'}}>
              <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 1)}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '166px', background: '#0D2926', textAlign: 'left'}}>
                  <img style={{width: '10px', height: '16px', tintColor: 'blue', transform: 'rotate(180deg)'}} src={'/images/icon_next.png'}/>
                  Back
                </div>
              </a>
            </div>
            <div style={{width: '166px'}}>
              <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 3)}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: '#209546', border: '2px solid #209546', padding: '16px', width: '166px', background: 'white', textAlign: 'left'}}>
                  Next
                  <img style={{width: '10px', height: '16px', tintColor: 'blue'}} src={'/images/icon_next_green.png'}/>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );

  }

  if(partialRepayment.input.stage === 3)
  {
    return (
      <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments
          calculator</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple
          steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in
          their home</h1>
        {menuBar(3, onChangeInput)}
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', padding: '0 100px'}}>
          <div style={{width: '100px', textAlign: 'center'}}>
            <img style={{width: '53px', height: '60px'}} src={'/images/icon_coin_small.png'}/>
            {(partialRepayment.input.repaymentPeriod === 'monthly') ? (
              <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', marginTop: '32px'}}>£0<br/>Monthly Minimum</h1>
            ):
              <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', marginTop: '32px'}}>£0<br/>Yearly Minimum</h1>
            }
          </div>
          <div style={{flexGrow: true, width: '100%', flexDirection: 'column'}}>
            <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>Your client can make voluntary repayments on their loan within this range</h1>
            <div style={{width: '90%', height: '1px', borderTop: '1px dashed #0D2926', margin: '0 auto'}}></div>
            <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>to</h1>
            {(partialRepayment.input.repaymentPeriod === 'monthly') ? (
                <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', marginTop: '32px'}}>+ £{Math.round(parseInt(partialRepayment.input.loanTaken) * (partialRepayment.input.interestTaken / 100) / 12, 10).toLocaleString()}<br/>Interest</h1>
              ):
              <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', marginTop: '32px'}}>+ £{Math.round(parseInt(partialRepayment.input.loanTaken) * (partialRepayment.input.interestTaken / 100), 10).toLocaleString()}<br/>Interest</h1>
            }
          </div>
          <div style={{width: '109px'}}>
            <img style={{width: '109px', height: '80px'}} src={'/images/icon_coin_large.png'}/>
            {(partialRepayment.input.repaymentPeriod === 'monthly') ? (
              <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', marginTop: '32px'}}>£{Math.round(parseInt(partialRepayment.output.maxYearlyLoan, 10) / 12).toLocaleString()}<br/>Monthly maximum, without incurring ERCs</h1>
            ):
              <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', marginTop: '32px'}}>£{Math.round(parseInt(partialRepayment.output.maxYearlyLoan, 10)).toLocaleString()}<br/>Yearly maximum, without incurring ERCs</h1>
            }
          </div>
        </div>
        <div style={{background: '#F2F2F2', padding: '48px', marginTop: '40px', textAlign: 'left'}}>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
            <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>See how repayments affect your client's lifetime mortgage and equity</h1>
            <div style={{display: 'flex', height: '34px', flexDirection: 'row'}}>
              <div onClick={() => onChangeInput('repaymentPeriod', 'monthly')} style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: (partialRepayment.input.repaymentPeriod === 'monthly') ? '#ffffff' : '#209546', border: '2px solid #209546', borderRight: '0px', padding: '3px', width: '114px', height: '34px', background: (partialRepayment.input.repaymentPeriod === 'monthly') ? '#209546' : '#ffffff', textAlign: 'center'}}>
                Monthly
              </div>
              <div onClick={() => onChangeInput('repaymentPeriod', 'yearly')} style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: (partialRepayment.input.repaymentPeriod === 'yearly') ? '#ffffff' : '#209546', border: '2px solid #209546', padding: '3px', width: '114px', height: '34px',background: (partialRepayment.input.repaymentPeriod === 'yearly') ? '#209546' : '#ffffff', textAlign: 'center'}}>
                Yearly
              </div>
            </div>
          </div>
          <div style={{width: '100%', height: '1px', borderTop: '1px solid #0D2926', margin: '20px auto'}}></div>
          <div style={{display: 'flex', flexDirection: 'column'}}>
            {[1,2,3].map((value, index) => {
              if(value > partialRepayment.input.currentRepayments)
              {
                return;
              }

              return (
                <div>
                  {(value > 1) ? (
                    <div style={{width: '100%', height: '1px', borderTop: '1px solid #0D2926', margin: '20px auto'}}></div>
                  ) : false }
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: '12px'}}>
                    <div style={{width: '40px'}}>
                      <img style={{width: '28px', height: '24px'}} src={'/images/icon_coins.png'}/>
                    </div>
                    <div style={{width: '250px', marginLeft: '10px'}}>
                      <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Repayment period {value}</h1>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <RangerInput
                        className="ranger"
                        style={{marginRight: '50px'}}
                        value={partialRepayment.input['stopPartialRepayment' + value]} min={1} max={15}
                        color={'#51bba4'} inactiveColor='#bbb' withLabel={true}
                        onChange={val => { onChangeInput('stopPartialRepayment' + value, val) }}
                        suffix={<span style={{paddingLeft: '5px'}}>years</span>}
                      />
                      {(!partialRepayment.input['interest' + value] && !partialRepayment.input['max' + value]) ? (
                        <TextInput
                          width={150} style={{ textAlign: 'right' }}
                          type="currency" prefixes="&pound;" value={((partialRepayment.input.repaymentPeriod === 'monthly') ? Math.round((parseInt(partialRepayment.input.loanTaken) * (partialRepayment.input.interestTaken / 100) / 12)) : Math.round(parseInt(partialRepayment.input.loanTaken) * (partialRepayment.input.interestTaken / 100), 10))}
                          onChange={val => { onChangeInput('capitalValue' + value, ((partialRepayment.input.repaymentPeriod === 'monthly') ? val * 12 : val)) }}
                        />
                      ):
                        <div className="text-input">
                          <div style={{ position: 'relative', width: '150px', background: 'white', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', padding: '8px', border: '2px #707070 solid' }}>
                            <div className="prefix">£</div>
                            {(partialRepayment.input.repaymentPeriod === 'monthly') ? (
                                <span style={{ width: '100%', textAlign: 'right'}}>{Math.round(partialRepayment.input['capitalValue' + value] / 12)}</span>
                            ):
                              <span style={{ width: '100%', textAlign: 'right'}}>{partialRepayment.input['capitalValue' + value]}</span>
                            }
                          </div>
                        </div>
                      }
                      {(partialRepayment.input.repaymentPeriod === 'monthly') ? (
                        <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', marginLeft: '16px'}}>Per month</h1>
                      ):
                        <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', marginLeft: '16px'}}>Per year</h1>
                      }
                      {((partialRepayment.input['capitalValue' + value]) > parseInt(partialRepayment.output.maxYearlyLoan, 10)) ? (
                        <div style={{ width: '200px', marginLeft: 20, marginRight: 20, color: 'red', fontSize: '12px' }}>
                          Please note, you may incur an ERC if you make this repayment
                        </div>
                      ):
                        <div style={{ width: '200px', marginLeft: 20, marginRight: 20, color: 'red', fontSize: '12px' }}>
                        </div>
                      }
                    </div>
                  </div>
                  <div style={{marginBottom: '16px', display: 'flex', flexDirection: 'row'}}>
                    <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
                      <div onClick={() => { onChangeInput('interest' + value, !partialRepayment.input['interest' + value]); onChangeInput('capitalValue' + value, Math.round(parseInt(partialRepayment.input.loanTaken) * (partialRepayment.input.interestTaken / 100), 10)); if(!partialRepayment.input['interest' + value] === true && partialRepayment.input['max' + value] === true) { onChangeInput('max' + value, false);} }} style={{position: 'relative'}}>
                        <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
                        {(partialRepayment.input['interest' + value]) ? (
                          <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
                        ): false}
                      </div>
                      <div style={{marginLeft: '32px', marginTop: '-10px'}}>
                        <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Pay the interest</h1>
                      </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', marginLeft: '48px', marginTop: '10px'}}>
                      <div onClick={() => {onChangeInput('max' + value, !partialRepayment.input['max' + value]); console.log(Math.round(parseInt(partialRepayment.output.maxYearlyLoan, 10))); onChangeInput('capitalValue' + value, Math.round(parseInt(partialRepayment.output.maxYearlyLoan, 10))); if(!partialRepayment.input['max' + value] === true && partialRepayment.input['interest' + value] === true) { onChangeInput('interest' + value, false); } }} style={{position: 'relative'}}>
                        <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
                        {(partialRepayment.input['max' + value]) ? (
                          <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
                        ): false}
                      </div>
                      <div style={{marginLeft: '32px', marginTop: '-10px'}}>
                        <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Pay the maximum</h1>
                      </div>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', marginLeft: '48px', marginTop: '10px'}}>
                      <div onClick={() => {onChangeInput('max' + value, false); onChangeInput('interest' + value, false);}} style={{position: 'relative'}}>
                        <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
                        {(partialRepayment.input['max' + value] === false && partialRepayment.input['interest' + value] === false) ? (
                          <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
                        ): false}
                      </div>
                      <div style={{marginLeft: '32px', marginTop: '-10px'}}>
                        <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Pay a custom amount</h1>
                      </div>
                    </div>
                  </div>
                  {(partialRepayment.input.currentRepayments > 1 && partialRepayment.input.currentRepayments === value) ? (
                    <div style={{marginBottom: '16px'}}>
                      <a onClick={() => { onChangeInput('currentRepayments', partialRepayment.input.currentRepayments - 1); onChangeInput('capitalValue1', 0); onChangeInput('capitalValue2', 0); onChangeInput('capitalValue3', 0);}} style={{pointer: 'cursor', textDecoration: 'underline', fontSize: '12px', marginRight: '24px', paddingBottom: '16px'}}>
                        Remove
                      </a>
                    </div>
                  ): false}
                </div>
              );
            })}
            {(partialRepayment.input.currentRepayments < 3) ? (
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                <div style={{width: '234px'}}>
                  <a  style={{cursor: 'pointer', textDecoration: 'none', width: '234px', margin: '67px auto'}} onClick={() => onChangeInput('currentRepayments', partialRepayment.input.currentRepayments + 1)}>
                    <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: '#209546', border: '2px solid #209546', padding: '6px', width: '234px', background: 'white', textAlign: 'left'}}>
                      Add repayment period
                      <img style={{width: '16px', height: '16px', tintColor: 'blue'}} src={'/images/tab_add.png'}/>
                    </div>
                  </a>
                </div>
              </div>
            ): false}
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '48px', paddingRight: '32px'}}>
            <div style={{width: '166px'}}>
              <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 2)}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '166px', background: '#0D2926', textAlign: 'left'}}>
                  <img style={{width: '10px', height: '16px', tintColor: 'blue', transform: 'rotate(180deg)'}} src={'/images/icon_next.png'}/>
                  Back
                </div>
              </a>
            </div>
            <div style={{width: '166px'}}>
              <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => {
                if(partialRepayment.input.capitalValue1 > 0)
                {
                  for(let i = 0; i <= partialRepayment.input.stopPartialRepayment1; i++)
                  {
                    partialRepayment.input.adHocPayments[i + 1] = Math.round(partialRepayment.input.capitalValue1);
                  }
                }

                if(partialRepayment.input.capitalValue2 > 0)
                {
                  let startPoint = partialRepayment.input.stopPartialRepayment1;
                  let endPoint = partialRepayment.input.stopPartialRepayment1 + partialRepayment.input.stopPartialRepayment2;

                  for(let i = startPoint; i < endPoint; i++)
                  {
                    partialRepayment.input.adHocPayments[i + 1] = Math.round(partialRepayment.input.capitalValue2);
                  }
                }

                if(partialRepayment.input.capitalValue3 > 0)
                {
                  let startPoint = partialRepayment.input.stopPartialRepayment1 + partialRepayment.input.stopPartialRepayment2;
                  let endPoint = partialRepayment.input.stopPartialRepayment1 + partialRepayment.input.stopPartialRepayment2 + partialRepayment.input.stopPartialRepayment3;

                  for(let i = startPoint; i < endPoint; i++)
                  {
                    partialRepayment.input.adHocPayments[i + 1] = Math.round(partialRepayment.input.capitalValue3);
                  }
                }

                onChangeInput('stage', 4);
              }}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: '#209546', border: '2px solid #209546', padding: '16px', width: '166px', background: 'white', textAlign: 'left'}}>
                  Next
                  <img style={{width: '10px', height: '16px', tintColor: 'blue'}} src={'/images/icon_next_green.png'}/>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if(partialRepayment.input.stage === 4)
  {
    return (
      <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments
          calculator</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple
          steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in
          their home</h1>
        {menuBar(4, onChangeInput)}
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center'}}>
          <img style={{width: '74px', height: '87px'}} src={'/images/icon_house.png'}/>
          <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', marginLeft: '16px', textAlign: 'left'}}>Your client could draw an additional <span style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>£{parseInt(partialRepayment.output.ltv.max - partialRepayment.input.loanTaken).toLocaleString()}</span><br/>from their home during their loan period</h1>
        </div>
        <div style={{background: '#F2F2F2', padding: '48px', marginTop: '40px', textAlign: 'left'}}>
          <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px'}}>See how drawing more funds could affect your client’s loan and equity (based current property value, age and on the rate of interest applied to the initial release)</h1>
          <div style={{width: '100%', height: '1px', borderTop: '1px solid #0D2926', margin: '20px auto'}}></div>
            {[1,2,3].map((value, index) => {
              if(value > partialRepayment.input.currentDrawdowns)
              {
                return;
              }

              return (
                <div style={{display: 'flex', flexDirection: 'column', marginBottom: '32px'}}>
                  {(value > 1) ? (
                    <div style={{width: '100%', height: '1px', borderTop: '1px solid #0D2926', margin: '20px auto'}}></div>
                  ) : false }
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    <div style={{width: '40px'}}>
                      <img style={{width: '28px', height: '24px'}} src={'/images/icon_calendar_green.png'}/>
                    </div>
                    <div style={{width: '250px', marginLeft: '10px'}}>
                      <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>When</h1>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <RangerInput
                        className="ranger"
                        style={{marginRight: '50px'}}
                        value={partialRepayment.input['drawdownYear' + value]} min={1} max={20}
                        color={'#51bba4'} inactiveColor='#bbb' withLabel={true}
                        onChange={val => { onChangeInput('drawdownYear' + value, val) }}
                        prefix={<span style={{paddingRight: '5px'}}>Year</span>}
                      />
                    </div>
                  </div>
                  <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '48px'}}>
                    <div style={{width: '40px'}}>
                      <img style={{width: '28px', height: '24px'}} src={'/images/icon_calendar_green.png'}/>
                    </div>
                    <div style={{width: '250px', marginLeft: '10px'}}>
                      <h1 style={{color: '#000000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>How much?</h1>
                    </div>
                    <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                      <TextInput
                        width={150} style={{ textAlign: 'right' }}
                        type="currency" prefixes="&pound;" value={partialRepayment.input['drawdownValue' + value]}
                        onChange={val => { onChangeInput('drawdownValue' + value, val) }}
                      />
                      {((partialRepayment.input['drawdownValue' + value]) > (partialRepayment.output.ltv.max - partialRepayment.input.loanTaken)) ? (
                        <div style={{ marginLeft: 20, marginRight: 20, color: 'red', fontSize: '12px' }}>
                          You cannot draw down more than maximum borrowing
                        </div>
                      ): false}
                    </div>
                  </div>
                  {(partialRepayment.input.currentDrawdowns > 1 && partialRepayment.input.currentDrawdowns === value) ? (
                    <a onClick={() => { onChangeInput('currentDrawdowns', partialRepayment.input.currentDrawdowns - 1); onChangeInput('drawdownValue1', 0); onChangeInput('drawdownValue1', 0); onChangeInput('drawdownValue2', 0); onChangeInput('drawdownValue3', 0);}} style={{pointer: 'cursor', textDecoration: 'underline', fontSize: '12px', marginRight: '24px', marginTop: '16px'}}>
                      Remove
                    </a>
                  ): false}
                </div>
              );
            })}
          {(partialRepayment.input.currentDrawdowns < 3) ? (
            <div style={{width: '234px'}}>
              <a  style={{textDecoration: 'none', width: '234px', margin: '67px auto'}} onClick={() => onChangeInput('currentDrawdowns', partialRepayment.input.currentDrawdowns + 1)}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: '#209546', border: '2px solid #209546', padding: '6px', width: '234px', background: 'white', textAlign: 'left'}}>
                  Draw more income
                  <img style={{width: '16px', height: '16px', tintColor: 'blue'}} src={'/images/tab_add.png'}/>
                </div>
              </a>
            </div>
          ): false}
          <div style={{fontSize: '12px', marginRight: '24px', paddingTop: '24px'}}>
            Any further borrowing will be calculated at the prevailing rate at the time of processing
          </div>
          <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginTop: '48px', paddingRight: '32px'}}>
            <div style={{width: '166px'}}>
              <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => onChangeInput('stage', 3)}>
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '166px', background: '#0D2926', textAlign: 'left'}}>
                  <img style={{width: '10px', height: '16px', tintColor: 'blue', transform: 'rotate(180deg)'}} src={'/images/icon_next.png'}/>
                  Back
                </div>
              </a>
            </div>
            <div style={{cursor: 'pointer', display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
              <span style={{fontSize: '12px', marginRight: '24px'}}>
                If no drawdown/further borrowing to be included, click the ‘Results’ button
              </span>
              <div style={{width: '166px'}}>
                <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto'}} onClick={() => {
                  if(partialRepayment.input.drawdownValue1 > 0)
                  {
                    partialRepayment.input.adHocDrawdown[partialRepayment.input.drawdownYear1] = Math.round(partialRepayment.input.drawdownValue1);
                  }

                  if(partialRepayment.input.drawdownValue2 > 0)
                  {
                    partialRepayment.input.adHocDrawdown[partialRepayment.input.drawdownYear2] = Math.round(partialRepayment.input.drawdownValue2);
                  }

                  if(partialRepayment.input.drawdownValue3 > 0)
                  {
                    partialRepayment.input.adHocDrawdown[partialRepayment.input.drawdownYear3] = Math.round(partialRepayment.input.drawdownValue3);
                  }

                  onChangeInput('stage', 5);
                }}>
                  <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: '#209546', border: '2px solid #209546', padding: '16px', width: '166px', background: 'white', textAlign: 'left'}}>
                    Results
                    <img style={{width: '10px', height: '16px', tintColor: 'blue'}} src={'/images/icon_next_green.png'}/>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{maxWidth: '1000px', margin: '20px auto', textAlign: 'center'}}>
      <div style={{display: (partialRepayment.input.displayForm) ? 'block' : 'none', position: 'absolute', width: '1000px', height: '1250px', background: 'white', zIndex: '1000'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Customer Service</h1>
        <div style={{margin: '0 auto', width: '568px', textAlign: 'left'}}>
          <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Name</h1>
          <TextInput
            width={564} style={{ textAlign: 'left' }}
            value={partialRepayment.input.formName}
            onChange={val => { onChangeInput('formName', val) }}
          />
        </div>
        <div style={{margin: '40px auto 0 auto', width: '568px', textAlign: 'left'}}>
          <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Business Email</h1>
          <TextInput
            width={564} style={{ textAlign: 'left' }}
            value={partialRepayment.input.formEmail}
            onChange={val => { onChangeInput('formEmail', val) }}
          />
        </div>
        <div style={{margin: '40px auto 0 auto', width: '568px', textAlign: 'left'}}>
          <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Company</h1>
          <TextInput
            width={564} style={{ textAlign: 'left' }}
            value={partialRepayment.input.formCompany}
            onChange={val => { onChangeInput('formCompany', val) }}
          />
        </div>
        <div style={{margin: '40px auto 0 auto', width: '568px', textAlign: 'left'}}>
          <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Case Number</h1>
          <TextInput
            width={564} style={{ textAlign: 'left' }}
            value={partialRepayment.input.formCaseNumber}
            onChange={val => { onChangeInput('formCaseNumber', val) }}
          />
        </div>
        <div style={{margin: '40px auto 0 auto', width: '568px', textAlign: 'left'}}>
          <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>What's on your mind?</h1>
          <TextInput
            width={564} style={{ textAlign: 'left' }}
            value={partialRepayment.input.formMessage}
            onChange={val => { onChangeInput('formMessage', val) }}
          />
        </div>
        <div style={{margin: '40px auto 0 auto', width: '568px', textAlign: 'left'}}>
          <input onChange={val => { onChangeInput('formPrivacyAgree', !partialRepayment.input.formPrivacyAgree) }} type="checkbox" id="vehicle1" name="vehicle1" value="Bike"/>
          <label style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}} htmlFor="vehicle1">I have read and understood the privacy policy</label>
        </div>
        <h1 style={{display: (partialRepayment.input.privacyError) ? 'block' : 'none', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', color: 'red'}}>You must agree to the privacy policy</h1>
        <div style={{width: '100px', margin: '40px auto 0 auto'}}>
          <a href="#" style={{textDecoration: 'none', width: '100px', margin: '67px auto'}} onClick={() => handleEmailSend(partialRepayment, onChangeInput)}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '100px', background: '#209546', textAlign: 'center'}}>
              Send
            </div>
          </a>
        </div>
        <div style={{width: '100px', margin: '10px auto 0 auto'}}>
          <a href="#" style={{textDecoration: 'none', width: '100px', margin: '67px auto'}} onClick={() => onChangeInput('displayForm', false)}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '100px', background: '#0D2926', textAlign: 'left'}}>
              <img style={{width: '10px', height: '16px', tintColor: 'blue', transform: 'rotate(180deg)'}} src={'/images/icon_next.png'}/>
              Back
            </div>
          </a>
        </div>
      </div>
      <div style={{display: (partialRepayment.input.displayFormComplete) ? 'block' : 'none', position: 'absolute', width: '1000px', height: '1250px', background: 'white', zIndex: '1000'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Customer Service</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Thanks for submitting your details. Our customer service team will be in touch with you soon</h1>

        <div style={{width: '100px', margin: '40px auto 0 auto'}}>
          <a href="#" style={{textDecoration: 'none', width: '100px', margin: '67px auto'}} onClick={() => onChangeInput('displayFormComplete', false)}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '100px', background: '#0D2926', textAlign: 'left'}}>
              <img style={{width: '10px', height: '16px', tintColor: 'blue', transform: 'rotate(180deg)'}} src={'/images/icon_next.png'}/>
              Back
            </div>
          </a>
        </div>
      </div>
      <div id={"displayGenerating"} style={{display: 'none', position: 'absolute', top: 'calc(50% - 150px)', left: 'calc(50% - 200px)', width: '400px', background: 'rgba(255,255,255,1)', boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px', borderRadius: 10, zIndex: '1000'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700, padding: '75px'}}>Generating report...</h1>
      </div>
      <div style={{display: (partialRepayment.input.adHocFormVisible) ? 'block' : 'none', position: 'absolute', width: '1000px', height: '1250px', background: 'white', zIndex: '1000'}}>
        <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Ad-hoc repayments and Drawdown</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Edit custom values below to see the difference on the graph</h1>

        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Drawdown Available: £{parseInt(partialRepayment.output.ltv.max - partialRepayment.input.loanTaken - drawdownSum).toLocaleString()}</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Interest (for the first year): £{Math.round(parseInt(partialRepayment.input.loanTaken) * (partialRepayment.input.interestTaken / 100), 10).toLocaleString()}</h1>
        <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Maximum repayment available without incurring an ERC: £{Math.round(parseInt(partialRepayment.output.maxYearlyLoan, 10)).toLocaleString()}</h1>

        <div style={{background: '#E8F4EC', width: '800px', margin: '20px auto', padding: '12px'}}>
          <table>
            <tr>
              <th style={{width: '50px'}}>Year</th>
              <th>Drawdown</th>
              <th>1st Jan</th>
              <th>Interest</th>
              <th>Payments</th>
              <th>Equity</th>
            </tr>
            {[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25].map((value, index) => {
              return (
                <tr>
                  <td style={{textAlign: 'left', width: '50px', fontSize: '16px'}}>
                    {value}
                  </td>
                  <td>
                    <TextInput
                      width={100} style={{ textAlign: 'left' }}
                      value={partialRepayment.input.adHocDrawdown[value]}
                      onChange={val => { handleAdhocChange('adHocDrawdown', value, onChangeInput, partialRepayment.input.adHocDrawdown, val); }}
                    />
                  </td>
                  <td style={{textAlign: 'center', width: '50px', fontSize: '16px'}}>
                    £{partialRepayment.output.series.noRepayments[index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td style={{textAlign: 'center', width: '50px', fontSize: '16px'}}>
                    £{parseFloat(partialRepayment.output.series.noRepayments[index] * (partialRepayment.input.interestTaken / 100)).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                  <td>
                    <TextInput
                      width={100} style={{ textAlign: 'left' }}
                      value={partialRepayment.input.adHocPayments[value]}
                      onChange={val => { handleAdhocChange('adHocPayments', value, onChangeInput, partialRepayment.input.adHocPayments, val); }}
                    />
                  </td>
                  <td style={{textAlign: 'center', width: '50px', fontSize: '16px'}}>
                    £{parseFloat(partialRepayment.output.series.futureHousePrice[index] - partialRepayment.output.series.partialRepayment[index]).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                  </td>
                </tr>
              );
            })}
          </table>
        </div>

        {(adhocPaymentValues.some(el => el > parseInt(partialRepayment.output.maxYearlyLoan))) ? (
          <div style={{ textAlign: 'center', color: 'red', fontSize: '14px' }}>
            Please note, you may incur an ERC if you make this repayment
          </div>
        ): false}

        <div style={{width: '100px', margin: '40px auto 40px auto', paddingBottom: '40px'}}>
          <a href="#" style={{textDecoration: 'none', width: '100px', margin: '67px auto'}} onClick={() => onChangeInput('adHocFormVisible', false)}>
            <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '100px', background: '#0D2926', textAlign: 'left'}}>
              Submit
            </div>
          </a>
        </div>
      </div>
      <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700}}>Retained equity and repayments
        calculator</h1>
      <h1 style={{color: '#0D2926', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px'}}>Follow 4 simple
        steps to see how your client’s repayments and drawdown will affect their<br/>loan and the estimated equity retained in
        their home</h1>
      {menuBar(5, onChangeInput)}

      <div style={{display: 'flex', flexDirection: 'row'}}>

        <div style={{width: '400px', marginRight: '32px', background: '#F3F7EA', padding: '32px'}}>
          <h1 style={{color: '#209546', fontFamily: 'Nunito Sans', fontWeight: 700, fontSize: '16px', textAlign: 'left'}}>Here’s how your client’s repayments and drawdowns influence their loan and home</h1>
          <div style={{width: '100%', height: '1px', borderTop: '1px solid #0D2926', margin: '20px auto'}}></div>

          <div style={{display: 'flex', flexDirection: 'row'}}>
            <div id="noRepaymentsButton" onClick={() => onChangeInput('showNoRepayments', !partialRepayment.input.showNoRepayments)} style={{position: 'relative'}}>
              <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
              {(partialRepayment.input.showNoRepayments) ? (
                <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
              ): false}
            </div>
            <div style={{marginLeft: '32px', marginTop: '-10px'}}>
              <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Show figures with no repayments</h1>
            </div>
          </div>

          <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
            <div id="withRepaymentsButton" onClick={() => onChangeInput('showRepayments', !partialRepayment.input.showRepayments)} style={{position: 'relative'}}>
              <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
              {(partialRepayment.input.showRepayments) ? (
                <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
              ): false}
            </div>
            <div style={{marginLeft: '32px', marginTop: '-10px'}}>
              <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Show figures with<br/>repayments</h1>
            </div>
          </div>

          <div style={{display: 'flex', flexDirection: 'row', marginTop: '10px'}}>
            <div id="drawdownButton" onClick={() => onChangeInput('showDrawdown', !partialRepayment.input.showDrawdown)} style={{position: 'relative'}}>
              <div style={{position: 'absolute', left: 0, top: 0, width: '20px', height: '20px', border: '1px solid #000', background: 'white', borderRadius: '10px'}}></div>
              {(partialRepayment.input.showDrawdown) ? (
                <div style={{position: 'absolute', left: 3, top: 3, width: '16px', height: '16px', background: '#209546', borderRadius: '10px'}}></div>
              ): false}
            </div>
            <div style={{marginLeft: '32px', marginTop: '-10px'}}>
              <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left'}}>Show impact of<br/>drawdown</h1>
            </div>
          </div>

          <div style={{width: '166px', margin: '10px auto 0 0'}}>
            {(partialRepayment.input.adHocEnabled == true) ? (
              <button onClick={() => onChangeInput('adHocFormVisible', true)} type={"submit"} style={{fontWeight: 700, textAlign: 'center', fontSize: '16px', cursor: 'pointer', textDecoration: 'none', width: '202px', margin: '0 auto', alignItems: 'center', color: '#1F9546', border: '2px solid #1F9546', padding: '16px', background: 'white'}}>
                Edit Data
              </button>
            ) : (
              <button onClick={() => {onChangeInput('adHocEnabled', true); onChangeInput('adHocFormVisible', true) }} type={"submit"} style={{fontWeight: 700, textAlign: 'center', fontSize: '16px', cursor: 'pointer', textDecoration: 'none', width: '202px', margin: '0 auto', alignItems: 'center', color: '#1F9546', border: '2px solid #1F9546', padding: '16px', background: 'white'}}>
                Edit Custom Data
              </button>
            )}
          </div>

          {(partialRepayment.input.adHocEnabled == true) ? (
            <h1 onClick={() => onChangeInput('adHocEnabled', false)} style={{cursor: 'pointer', color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '16px', textAlign: 'left', textDecoration: 'underline'}}>
              Reset Data
            </h1>
          ) : false }

          <h1 style={{color: '#000', fontFamily: 'Nunito Sans', fontWeight: 400, fontSize: '12px', textAlign: 'left'}}>
            Shows annual breakdown
            <br/>and/or add ad-hoc
            <br/>repayments or drawdown
          </h1>

          <div style={{width: '166px', margin: '67px auto 0 0'}}>
            <a href="#" style={{textDecoration: 'none', width: '166px', margin: '67px auto 0 auto'}} onClick={() => {onChangeInput('adHocEnabled', false); onChangeInput('stage', 4)}}>
              <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', width: '166px', background: '#0D2926', textAlign: 'left'}}>
                <img style={{width: '10px', height: '16px', tintColor: 'blue', transform: 'rotate(180deg)'}} src={'/images/icon_next.png'}/>
                Back
              </div>
            </a>
          </div>

          <div style={{width: '166px', margin: '10px auto 0 0'}}>
            <form id="pdfForm" target="_blank" method="POST" action="https://rer-api-dev.moreish.host/process_pdf.php?brand=more2life">
              <input type="hidden" value={partialRepayment.input.advisorName} name={"advisorName"} />

              <input type="hidden" value={partialRepayment.input.clientAge} name={"clientAge"} />
              <input type="hidden" value={partialRepayment.input.housePrice} name={"housePrice"} />
              <input type="hidden" value={partialRepayment.input.loanTaken} name={"loanTaken"} />
              <input type="hidden" value={partialRepayment.input.interestTaken} name={"interestTaken"} />
              <input type="hidden" value={partialRepayment.input.futureHousePricePct} name={"futureHousePrice"} />
              <input type="hidden" value={partialRepayment.input.capitalValue1} name={"capitalValue1"} />
              <input type="hidden" value={partialRepayment.input.stopPartialRepayment1} name={"stopPartialRepayment1"} />
              <input type="hidden" value={partialRepayment.input.drawdownValue1} name={"drawdownValue1"} />
              <input type="hidden" value={partialRepayment.input.drawdownYear1} name={"drawdownYear1"} />

              <input type="hidden" value={partialRepayment.input.logo} name={"fileUpload"} />

              <input type="hidden" id="graphTable" name={"table"} />
              <input type="hidden"  id="graphAll" name={"graphAll"} />

              <input type="hidden" id="graph2" name={"graph2"} />
              <input type="hidden" id="graph3" name={"graph3"} />
              <input type="hidden" id="graph4" name={"graph4"} />
              <input type="hidden" id="graph5" name={"graph5"} />

              <button type={"submit"} style={{textAlign: 'center', fontSize: '16px', cursor: 'pointer', textDecoration: 'none', width: '202px', margin: '0 auto', alignItems: 'center', color: 'white', border: '2px solid white', padding: '16px', background: '#1F9546'}}>
                Print Report
              </button>
            </form>

          </div>

          <div style={{width: '166px', margin: '10px auto 0 0'}}>
            <button onClick={() => onChangeInput('displayForm', true)} type={"submit"} style={{fontWeight: 700, textAlign: 'center', fontSize: '16px', cursor: 'pointer', textDecoration: 'none', width: '202px', margin: '0 auto', alignItems: 'center', color: '#1F9546', border: '2px solid #1F9546', padding: '16px', background: 'white'}}>
              Speak to<br/>customer service
            </button>
          </div>
        </div>
        <div style={{width: '100%'}}>
          <ChartSeries {...partialRepayment.output} />
          <TableSeries {...partialRepayment.output} />
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/PartialRepayment/PartialRepaymentComponent.js